import React from "react";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";

import { ExtractSwarovskiPageData, IntendedUsePageData } from "@swo/storefront";
import { FooterComponent } from "../../components/FooterComponent/FooterComponent";
import { HeaderComponent } from "../../components/HeaderComponent/HeaderComponent";
import { PageMetadataComponent } from "../../components/PageMetadataComponent/PageMetadataComponent";
import { Spacer } from "../../components/_shared-components/arrangement/Space";
import { useStore } from "../../store/hooks/use-store";
import { HeaderSpacer } from "../_layout-helpers/spacers";
import { IntendedUseRoot } from "./IntendedUseRoot";

export const IntendedUsePageLayout: ReactTFC<ExtractSwarovskiPageData<IntendedUsePageData>> = props => {
  const { locationOrigin } = useStore().state;
  const { metadata, header, footer, ...rest } = props.data;

  return (
    <>
      <PageMetadataComponent
        {...metadata}
        locationOrigin={locationOrigin}
        canonicalPath={props.page.path}
        languageIsoCode={props.locale.language.isoCode}
      />

      <HeaderComponent header={header} version={"normal"} />
      <HeaderSpacer />

      <IntendedUseRoot {...rest} />

      <Spacer size={"md"} />
      <FooterComponent {...footer} />
    </>
  );
};
